export function scrollToId(id) {
    const el = document.getElementById(id);
    if (!el) return;
    if (window.__lenis) window.__lenis.scrollTo(el, { offset: -76, duration: 1.1 });
    else el.scrollIntoView({ behavior: "smooth" });
}

export function scrollToTop() {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
}
